import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8a816f84&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a816f84')) {
      api.createRecord('8a816f84', component.options)
    } else {
      api.reload('8a816f84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8a816f84&", function () {
      api.rerender('8a816f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/server/index.vue"
export default component.exports